import { render, staticRenderFns } from "./accountsDetail.vue?vue&type=template&id=1f5ba7ce&scoped=true&"
import script from "./accountsDetail.vue?vue&type=script&lang=js&"
export * from "./accountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountsDetail.vue?vue&type=style&index=0&id=1f5ba7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ba7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5ba7ce')) {
      api.createRecord('1f5ba7ce', component.options)
    } else {
      api.reload('1f5ba7ce', component.options)
    }
    module.hot.accept("./accountsDetail.vue?vue&type=template&id=1f5ba7ce&scoped=true&", function () {
      api.rerender('1f5ba7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/accountsDetail.vue"
export default component.exports